import { render, staticRenderFns } from "./userLevel.vue?vue&type=template&id=5561eb17&scoped=true&"
import script from "./userLevel.vue?vue&type=script&lang=js&"
export * from "./userLevel.vue?vue&type=script&lang=js&"
import style0 from "./userLevel.vue?vue&type=style&index=0&id=5561eb17&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5561eb17",
  null
  
)

export default component.exports